import type { PagesConfig } from '#types/config/pages'

export default {
  brandClasses: {
    formsWrapper: 'grid md:(cols-2 divide-x) divide-grey-50 <md:divide-y',
    heading: 'title-1',
    trackOrderButton: 'mt-6 w-full'
  },
  orderNumberLengths: [8],
  orderStatusHelpText: {
    requiredLocales: [
      'en-gb',
      'nl-nl'
    ]
  }
} satisfies PagesConfig['orderStatus']
